import { createContext, useContext } from 'react';

// Stub — WebSocket streaming non encore implémenté dans admin-web
const WebSocketContext = createContext(null);

export function WebSocketProvider({ children }) {
  return (
    <WebSocketContext.Provider value={null}>
      {children}
    </WebSocketContext.Provider>
  );
}

export function useWebSocket() {
  return useContext(WebSocketContext);
}
